import type { CampaignInfo } from 'app/src/model'
import { membershipApi, shoppingApi } from 'app/src/services/welfareportal'
import { BalanceWidget, HelloWidget, TimerWidget } from 'app/src/shared/components'
import { getFunnelDiscount } from 'app/src/shared/helpers'
import { useWebAppContext } from 'app/src/shared/hooks'
import Skeleton from 'react-loading-skeleton'

export function TimerAndBalanceSection() {
  const context = useWebAppContext()
  const funnelDiscount = getFunnelDiscount(context)
  const phaseAndDeadline: CampaignInfo = membershipApi.getPhaseAndDeadline(context.userInfo.welfareCampaign)

  const credit = shoppingApi.useCreditGet(
    {},
    {
      enabled: phaseAndDeadline.phase == 'fruition' && !funnelDiscount.onlyDiscount,
      meta: {
        skip404Errors: true,
      },
    },
  )

  const isLoading = credit.isLoading
  const isOnlyDiscount = funnelDiscount?.onlyDiscount

  // Usa conditional rendering invece di early returns per mantenere
  // lo stesso numero di hooks tra render (previene React error #310)
  return (
    <div
      className='mx-auto min-h-[150px]'
      data-testid={
        isLoading
          ? 'TimerAndBalanceSectionSkeleton'
          : isOnlyDiscount
            ? 'TimerAndBalanceSectionOnlyDiscount'
            : 'TimerAndBalanceSection'
      }
    >
      {isLoading ? (
        <Skeleton height={150} baseColor='#e5e7eb' highlightColor='#f3f4f6' data-testid='loading-element' />
      ) : isOnlyDiscount ? (
        <div className='py-8'>
          <HelloWidget name={context.userInfo.firstName}></HelloWidget>
        </div>
      ) : phaseAndDeadline.phase == 'fruition' &&
        !credit.isError &&
        credit.data?.creditByServiceCategory?.welfareArt100?.available ? (
        <div className='grid sm:grid-cols-1 lg:grid-cols-2'>
          <div>
            <div className='grid grid-rows-2'>
              <div className='mb-6 w-full max-w-[100%] lg:mb-0 lg:overflow-auto'>
                <HelloWidget name={context.userInfo.firstName}></HelloWidget>
              </div>
              <div>
                <TimerWidget />
              </div>
            </div>
          </div>
          <div className='grid grid-cols-12'>
            <div className='col-span-12 col-start-1 pt-6 lg:col-span-7 lg:col-start-6 lg:mt-[0px]'>
              <BalanceWidget balance={credit.data?.creditByServiceCategory?.welfareArt100?.available} />
            </div>
          </div>
        </div>
      ) : (
        <div className='grid sm:grid-cols-1 lg:grid-cols-2'>
          <div>
            <HelloWidget name={context.userInfo.firstName}></HelloWidget>
          </div>
          <div>
            <TimerWidget />
          </div>
        </div>
      )}
    </div>
  )
}
